"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

exports.__esModule = true;

var React = require("react");

var Linkify = require("linkifyjs/react");

function splitMessage(message) {
  var breakIndex = message.indexOf('\n'); // consider that there can be line without a break

  if (breakIndex === -1) {
    return message;
  }

  return message.substr(0, breakIndex);
}

var ErrorPanel =
/** @class */
function (_super) {
  __extends(ErrorPanel, _super);

  function ErrorPanel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ErrorPanel.prototype.render = function () {
    var log = this.props.log;
    /* This checks for error logTypes and shortens the message in the console by wrapping
    it a <details /> tag and putting the first line in a <summary /> tag and the other lines
    follow after that. This creates a nice collapsible error message */

    var otherErrorLines;
    var msgLine = log.data.join(' ');
    var firstLine = splitMessage(msgLine);
    var msgArray = msgLine.split('\n');

    if (msgArray.length > 1) {
      otherErrorLines = msgArray.slice(1);
    }

    if (!otherErrorLines) {
      return React.createElement(Linkify, null, log.data.join(' '));
    }

    return React.createElement("details", null, React.createElement("summary", {
      style: {
        outline: 'none',
        cursor: 'pointer'
      }
    }, firstLine), React.createElement(Linkify, null, otherErrorLines.join('\n\r')));
  };

  return ErrorPanel;
}(React.PureComponent);

exports["default"] = ErrorPanel;